interface SectionLabelProps {
  children: string;
}

export default function SectionLabel({ children }: SectionLabelProps) {
  return (
    <div className="flex items-center gap-3 mb-4">
      <span className="block w-6 h-px bg-gold" />
      <span className="font-label text-sm tracking-widest text-gold uppercase">
        {children}
      </span>
    </div>
  );
}
